import React from "react";
import FullPageLoading from "../../layout/Loading/FullPageLoading";
import useIsAuthenticated from "../../../../hooks/useIsAuthenticated";

const withRequireAuth = (BaseComponent) => (props) => {
    const isAuthenticated = useIsAuthenticated();

    if (!isAuthenticated) {
        return <FullPageLoading />;
    }

    return <BaseComponent {...props} />;
};

export default withRequireAuth;
